import React, { useMemo, useState } from 'react'

import { ArrowDirectionIcon } from '@application/Interfaces/Icons'
import { Grid } from '@icontainers/design-system/dist/atoms/Grid'
import { Button } from '@icontainers/design-system/dist/molecules/Button'
import { CardsWithTabComponentType } from '@src/Application/Types/ComponentTypes'

import {
    CTALink,
    Icon,
    ImageWrapper,
    Item,
    ItemDescription,
    ItemTitle,
    ReadMore,
    Tabs,
    TitleSection,
} from './CardsWithTab.styled'
import { handleTabChange } from './utils'

export const CardsWithTab = (props: CardsWithTabComponentType): JSX.Element => {
    const { className, mode, title, subtitle, cardWithTabDescription, tabs, ctaButtonLabel, ctaButtonLink } = props

    const [selectedTab, setSelectedTab] = useState('0')

    const cards = useMemo(() => tabs[parseInt(selectedTab)].cards, [selectedTab, tabs])

    return (
        <TitleSection
            title={title}
            subtitle={subtitle}
            mode={mode}
            description={cardWithTabDescription}
            className={className}
        >
            <Tabs
                id="routes"
                size="default"
                variant="scrollable"
                underline={false}
                pillStyled
                fullWidthTab
                tabs={tabs.map((tab, index) => ({ id: `${index}`, value: `${index}`, label: tab.tabTitle }))}
                onChangeCallback={handleTabChange(setSelectedTab)}
            />
            <Grid container mdUpSpacingTop={10} mdDownSpacingTop={3}>
                {cards.map((card, index) => (
                    <Grid
                        item
                        xs={12}
                        sm={6}
                        md={3}
                        key={`${index}-card`}
                        spacingBottom={3}
                        mdUpSpacingBottom={4}
                        mdUpSpacingRight={4}
                    >
                        <Item $mode={mode}>
                            {card.image && (
                                <ImageWrapper>
                                    <Icon image={card.image} />
                                </ImageWrapper>
                            )}
                            <ItemTitle>{card.title}</ItemTitle>
                            {card.description && <ItemDescription>{card.description}</ItemDescription>}
                            {card.link && card.linkLabel && (
                                <ReadMore to={card.link}>
                                    <span>{card.linkLabel}</span>
                                    <ArrowDirectionIcon colorCode="p500" />
                                </ReadMore>
                            )}
                        </Item>
                    </Grid>
                ))}
            </Grid>
            {ctaButtonLink && ctaButtonLabel && (
                <Grid container justifyContent="center" mdUpSpacingTop={6}>
                    <CTALink to={ctaButtonLink}>
                        <Button>{ctaButtonLabel}</Button>
                    </CTALink>
                </Grid>
            )}
        </TitleSection>
    )
}
